<script>
  export let type = 'title-medium',
    tag = 'h3',
    purple = false,
    pink = false,
    orange = false,
    black = false,
    white = false,
    marginBottom = 0,
    marginBottomDesktop = 0;

  const defaultMarginBottom = 0;
  const defaultMarginBottomDesktop = 0;

  const getClasses = (type) => {
    const margin =
      marginBottom !== defaultMarginBottom || marginBottomDesktop !== defaultMarginBottomDesktop
        ? ' margin'
        : '';
    return `heading heading--${type}${margin}`;
  };

  const getStyles = (marginBottom, marginBottomDesktop) => {
    if (
      marginBottom !== defaultMarginBottom ||
      marginBottomDesktop !== defaultMarginBottomDesktop
    ) {
      return `--marginBottom: ${marginBottom}; --marginBottomDesktop: ${marginBottomDesktop};`;
    }
  };
</script>

<style lang="scss">
  @import '../../styles/tools/media-query';
  @import '../../styles/settings/core';
  @import '../../styles/settings/colors';

  .heading {
    display: block;
    margin: 0;
    padding: 0;
    font-weight: 600;
    white-space: break-spaces;
    word-break: keep-all;
  }

  .heading--display-1 {
    font-size: 5.8rem;
    line-height: 6.4rem;
    letter-spacing: -0.102rem;
    margin-block-end: spacing(3);

    @include mq($from: tabletportrait) {
      font-size: 9.3rem;
      line-height: 8.8rem;
      letter-spacing: -0.163rem;
      margin-block-end: spacing(4);
    }
  }

  .heading--display-2 {
    font-size: 4.6rem;
    line-height: 4.8rem;
    letter-spacing: -0.083rem;
    margin-block-end: spacing(3);

    @include mq($from: tabletportrait) {
      font-size: 7.2rem;
      line-height: 7.6rem;
      letter-spacing: -0.128rem;
      margin-block-end: spacing(4);
    }
  }

  .heading--title-2xl {
    font-size: 3.2rem;
    line-height: 4rem;
    letter-spacing: -0.105rem;
    margin-block-end: spacing(3);

    @include mq($from: tabletportrait) {
      font-size: 5.8rem;
      line-height: 6.4rem;
      letter-spacing: -0.105rem;
    }
  }

  .heading--title-xl {
    font-size: 2.8rem;
    line-height: 3.2rem;
    letter-spacing: -0.105rem;
    margin-block-end: spacing(3);

    @include mq($from: tabletportrait) {
      font-size: 3.2rem;
      line-height: 4rem;
      letter-spacing: -0.056rem;
    }
  }

  .heading--title-large {
    font-size: 2.2rem;
    line-height: 2.8rem;
    letter-spacing: -0.024rem;
    margin-block-end: spacing(3);

    @include mq($from: tabletportrait) {
      font-size: 2.8rem;
      line-height: 3.2rem;
      letter-spacing: -0.048rem;
    }
  }

  .heading--title-medium {
    font-size: 2rem;
    line-height: 2.8rem;
    letter-spacing: -0.02rem;
    font-weight: 500;
    margin-block-end: spacing(3);

    @include mq($from: tabletportrait) {
      font-size: 2.2rem;
      line-height: 2.8rem;
      letter-spacing: -0.024rem;
    }
  }

  .heading--title-heading {
    font-size: 1.8rem;
    line-height: 2.4rem;
    letter-spacing: -0.02rem;
    margin-block-end: spacing(3);

    @include mq($from: tabletportrait) {
      font-size: 2rem;
      line-height: 2.8rem;
      letter-spacing: -0.02rem;
    }
  }

  .heading--title-body {
    font-size: 1.6rem;
    line-height: 2.4rem;
    letter-spacing: -0.016rem;
    margin-block-end: spacing(3);
  }

  .heading--page-header {
    font-size: 2.8rem;
    line-height: 4rem;
    letter-spacing: -0.105rem;
    margin-block-start: spacing(4);
    margin-block-end: spacing(2);

    @include mq($from: tabletportrait) {
      font-size: 3.2rem;
      line-height: 4rem;
      letter-spacing: -0.056rem;
    }

    @include mq($from: desktop) {
      margin-block-end: spacing(3);
    }
  }

  .margin {
    margin-block-end: var(--marginBottom);

    @include mq($from: desktop) {
      margin-block-end: var(--marginBottomDesktop);
    }
  }

  .purple {
    color: $purple-50;
  }

  .orange {
    color: $orange-50;
  }

  .pink {
    color: $pink-50;
  }

  .white {
    color: $white;
  }

  .black {
    color: $black;
  }
</style>

{#if tag === 'h1'}
  <h1
    class={getClasses(type)}
    style={getStyles(marginBottom, marginBottomDesktop)}
    class:purple
    class:pink
    class:black
    class:white
    class:orange
  >
    <slot />
  </h1>
{:else if tag === 'h2'}
  <h2
    class={getClasses(type)}
    style={getStyles(marginBottom, marginBottomDesktop)}
    class:purple
    class:pink
    class:black
    class:white
    class:orange
  >
    <slot />
  </h2>
{:else if tag === 'h3'}
  <h3
    class={getClasses(type)}
    style={getStyles(marginBottom, marginBottomDesktop)}
    class:purple
    class:pink
    class:black
    class:white
    class:orange
  >
    <slot />
  </h3>
{:else if tag === 'h4'}
  <h4
    class={getClasses(type)}
    style={getStyles(marginBottom, marginBottomDesktop)}
    class:purple
    class:pink
    class:black
    class:white
    class:orange
  >
    <slot />
  </h4>
{:else if tag === 'h5'}
  <h5
    class={getClasses(type)}
    style={getStyles(marginBottom, marginBottomDesktop)}
    class:purple
    class:pink
    class:black
    class:white
    class:orange
  >
    <slot />
  </h5>
{:else if tag === 'h6'}
  <h6
    class={getClasses(type)}
    style={getStyles(marginBottom, marginBottomDesktop)}
    class:purple
    class:pink
    class:black
    class:white
    class:orange
  >
    <slot />
  </h6>
{:else}
  <slot />
{/if}
